import { useMemo } from 'react'
import { aClient, useAtomValue } from '~/atoms'
import { Button, SelectMultiple, Separator } from '~/components/ui'
import { PROPERTY_TYPES } from '~/constants'
import { valuesToValueLabelOptions } from '~/lib'

export default function MapPropertyTypesFilter({
  propertyTypes,
  updateFilter,
}: {
  propertyTypes: string[]
  updateFilter: (key: string, value: any) => void
}) {
  const client = useAtomValue(aClient)

  const allPropertyTypes: string[] = useMemo(() => {
    if (client.find && client.find.property_types) {
      if (client.find.property_types.$in) {
        return client.find.property_types.$in
      } else if (client.find.property_types.$nin) {
        return PROPERTY_TYPES.filter(
          (p) => client.find!.property_types.$nin.includes(p) === false
        )
      }
    }
    return PROPERTY_TYPES
  }, [client])

  const options = valuesToValueLabelOptions(allPropertyTypes)

  return (
    <div className="space-y-2">
      <Separator />
      <p className="text-sm">
        Primary Use
        {propertyTypes.length > 0 && (
          <Button
            variant="link"
            size="none"
            className="ml-2"
            onClick={() => updateFilter('property_types', [])}>
            (reset)
          </Button>
        )}
      </p>
      <SelectMultiple
        placeholder="Select Primary Use..."
        options={options}
        selected={valuesToValueLabelOptions(propertyTypes)}
        setSelected={(selected) => {
          updateFilter(
            'property_types',
            selected.map(({ value }) => value)
          )
        }}
      />
    </div>
  )
}
